import {
  createRouteRef,
  createSubRouteRef,
} from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();

export const announcementAdminRouteRef = createSubRouteRef({
  path: '/admin',
  parent: rootRouteRef,
});

export const announcementCreateRouteRef = createSubRouteRef({
  path: '/create',
  parent: rootRouteRef,
});

export const announcementEditRouteRef = createSubRouteRef({
  path: '/edit/:id',
  parent: rootRouteRef,
});

export const announcementViewRouteRef = createSubRouteRef({
  path: '/view/:id',
  parent: rootRouteRef,
});
